module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-center box-body"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.ruleCodeOptions,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "贈送優惠券規則",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    on: {
      "select": _vm.reNewMenu
    },
    model: {
      value: (_vm.newCouponType),
      callback: function($$v) {
        _vm.newCouponType = $$v
      },
      expression: "newCouponType"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giveCoupons.coupon_strategy.name),
      expression: "giveCoupons.coupon_strategy.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.giveCoupons.coupon_strategy.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.giveCoupons.coupon_strategy, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giveCoupons.coupon_strategy.description),
      expression: "giveCoupons.coupon_strategy.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "maxlength": "256"
    },
    domProps: {
      "value": (_vm.giveCoupons.coupon_strategy.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.giveCoupons.coupon_strategy, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br')])]), _vm._v(" "), (_vm.newCouponType) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-left box-body"
  }, [(_vm.ruleCode === 'SC00003') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giveCoupons.coupon_strategy.setting.money_unit),
      expression: "giveCoupons.coupon_strategy.setting.money_unit"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.giveCoupons.coupon_strategy.setting.money_unit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.giveCoupons.coupon_strategy.setting, "money_unit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.ruleCode === 'SC00001') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品限制最低單價")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giveCoupons.coupon_strategy.setting.lowest_unit_price),
      expression: "giveCoupons.coupon_strategy.setting.lowest_unit_price"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.giveCoupons.coupon_strategy.setting.lowest_unit_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.giveCoupons.coupon_strategy.setting, "lowest_unit_price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("一次最大使用張數")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giveCoupons.coupon_strategy.setting.one_max_amount),
      expression: "giveCoupons.coupon_strategy.setting.one_max_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.giveCoupons.coupon_strategy.setting.one_max_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.giveCoupons.coupon_strategy.setting, "one_max_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), (_vm.newCouponType) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "form-center box-body"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giveCoupons.coupon_strategy.limit.min_amount),
      expression: "giveCoupons.coupon_strategy.limit.min_amount"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.giveCoupons.coupon_strategy.limit.min_amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.giveCoupons.coupon_strategy.limit, "min_amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "form-left box-body"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          訂單類型\n        ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.orderType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "訂單類型",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.giveCoupons.coupon_strategy.limit.order_types),
      callback: function($$v) {
        _vm.$set(_vm.giveCoupons.coupon_strategy.limit, "order_types", $$v)
      },
      expression: "giveCoupons.coupon_strategy.limit.order_types"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          訂單方案\n        ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.orderMethod,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": true,
      "placeholder": "訂單方案",
      "show-labels": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.giveCoupons.coupon_strategy.limit.order_method),
      callback: function($$v) {
        _vm.$set(_vm.giveCoupons.coupon_strategy.limit, "order_method", $$v)
      },
      expression: "giveCoupons.coupon_strategy.limit.order_method"
    }
  })], 1)]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "form-right box-body"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          取貨方式\n        ")]), _vm._v(" "), _c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.deliveryType,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "placeholder": "取貨方式",
      "show-labels": false,
      "multiple": true,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.giveCoupons.coupon_strategy.limit.delivery_types),
      callback: function($$v) {
        _vm.$set(_vm.giveCoupons.coupon_strategy.limit, "delivery_types", $$v)
      },
      expression: "giveCoupons.coupon_strategy.limit.delivery_types"
    }
  })], 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("限制主單(或團長)最低總金額(單位：元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giveCoupons.coupon_strategy.limit.min_money),
      expression: "giveCoupons.coupon_strategy.limit.min_money"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.giveCoupons.coupon_strategy.limit.min_money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.giveCoupons.coupon_strategy.limit, "min_money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr', {
    staticClass: "box-body"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [(_vm.ruleCode === 'SC00001' || _vm.ruleCode === 'SC00003') ? _c('h5', [_vm._v("例外商品選擇")]) : _c('h5', [_vm._v("指定商品選擇")])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.ruleCode === 'SC00002') ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]) : _vm._e(), _vm._v("選擇參與店家菜單")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.storeList,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "店家",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  }, [_vm._v("addExProdToList\n          ")])], 1), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.ruleCode === 'SC00001') ? _c('menu-discount', {
    attrs: {
      "className": 'cs-ae',
      "menuId": _vm.menuSelect.value,
      "showWord": '排除'
    },
    on: {
      "addProdToList": _vm.addExProdToList
    }
  }) : (_vm.ruleCode === 'SC00002') ? _c('menu-discount', {
    attrs: {
      "className": 'cs-pt',
      "menuId": _vm.menuSelect.value,
      "showWord": '加入'
    },
    on: {
      "addProdToList": _vm.addProdToList
    }
  }) : (_vm.ruleCode === 'SC00003') ? _c('menu-discount', {
    attrs: {
      "className": 'cs-pt-3',
      "menuId": _vm.menuSelect.value,
      "showWord": '排除'
    },
    on: {
      "addProdToList": _vm.addExProdToList3
    }
  }) : _vm._e(), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.store_exception_items[0].products.length && (_vm.ruleCode === 'SC00001' || _vm.ruleCode === 'SC00003')) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.giveCoupons.coupon_strategy.store_exception_items[0].products), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(aIndex + 1) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(aProduct.product_name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.giveCoupons.coupon_strategy.store_exception_items[0].products, aIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.giveCoupons.coupon_strategy.setting.vendor_custom_product_list.length && _vm.ruleCode === 'SC00002') ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.giveCoupons.coupon_strategy.setting.vendor_custom_product_list), function(aProduct, aIndex) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(aIndex + 1) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(aProduct.product_name) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(aProduct.vendor_custom_id))])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.giveCoupons.coupon_strategy.setting.vendor_custom_product_list, aIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("優惠券折抵規則\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("折抵策略名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("折抵描述")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', [_c('h4', [_vm._v("使用規則")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("滿足商品金額 (買X元，送優惠券)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body form-center"
  }, [_c('div', [_c('h4', [_vm._v("限制規則")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("限制主單(或團長)最低購買數(單位：個)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary"
  }, [_c('tr', [_c('td', [_vm._v("＃")]), _vm._v(" "), _c('td', [_vm._v("商品")]), _vm._v(" "), _c('td', [_vm._v("商品料號")]), _vm._v(" "), _c('td')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ac6660e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Marketing/Temp/CouponStrategy.vue
// module id = 2384
// module chunks = 1